export default __webpack_public_path__ + "static/media/delivery.be1e2de3.jpg";